import axios from 'axios';
import store from './store';
import { refreshToken } from './actions/authAction';
import { LOGOUT } from './actions/types';

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;
      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest._retry &&
        localStorage.getItem('refresh')
      ) {
        originalRequest._retry = true;
        try {
          const res = await store.dispatch(refreshToken());
          if (res && res.access) {
            originalRequest.headers['Authorization'] = `JWT ${res.access}`;
            return axios(originalRequest);
          }
        } catch (err) {
          store.dispatch({ type: LOGOUT });
          window.location.href = '/login';
        }
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.code === 'token_not_valid'
      ) {
        store.dispatch({ type: LOGOUT });
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;